import { AbstractStateful, setStatefulSymbols } from '../../types/lux'
import { deriveValues } from './derive'
import { safeAssign } from './lib'
import { DeriverSeer, InstanceSeer } from './Seer'

export default AbstractStateful
// export default class Stateful extends AbstractStateful {}

// const INITIAL_SATE={}
// refactor stateful into using stateful seer

/** @constructor @extends {AbstractStateful} @suppress {checkTypes} */ function _Stateful() {}
AbstractStateful.__implement(InstanceSeer,
  _Stateful.prototype = /** @type {!AbstractStateful} */ ({
    initialiser({ state }) {
      setStatefulSymbols(this, {
        _initialState: state,
      })
      return this
    },
    // get initialState() {
    //   const{_initialState}=getStatefulSymbols(this)
    //   setStatefulSymbols(this, {
    //     _initialState:INITIAL_SATE,
    //   })
    //   return _initialState
    // },
    setState(newState) {
      let { asIStateful: { state } } = this
      if (!state) { // an edge case if the stateful __$constructor wasn't called yet
        state = {}
        setStatefulSymbols(this, {
          _state: state,
        })
      }
      const { allSame } = safeAssign(newState, state)
      return { allSame }
    },
    setDerivedState(derivedState,instance) {
      const{asIStateful:{setState}}=this
      const seer=new DeriverSeer()
      seer.cb=setState
      seer.derivedProps=derivedState
      seer.instance=instance||null
      const values=deriveValues(derivedState,instance,null,seer)
      setState(values)
    },
    setDerivedStateDelayed(derivedState, instance) {
      setTimeout(() => {
        const{asIStateful:{setDerivedState}}=this
        setDerivedState(derivedState,instance)
      }, 1)
    },
    // refactor those into multiple seers instead of Object.keys lookup
    // setDerivedState(derivedState, instance) {
    //   const {asIStateful:{derivedStates}} = this
    //   derivedStates.push({ derivedState, instance })
    //   const stateValues=deriveValues(derivedState, instance, null, this)
    //   const { asIStateful: { setState } } = this
    //   setState(stateValues)
    // },
    // __$see({data}) {
    //   const {asIStateful:{derivedStates,setState}} = this
    //   const allStateValues = {}
    //   for (const { derivedState, instance } of derivedStates) {
    //     const stateValues = deriveValues(derivedState, instance, [data])
    //     Object.assign(allStateValues, stateValues)
    //   }
    //   if (Object.keys(allStateValues).length) setState(allStateValues)
    // },
  }),
)
